import React, {

  createContext,

  useCallback,

  useContext,

  useMemo,

  useState,

} from 'react';

import { loadTenantConfig } from '../services/tenantsService';



const TenantContext = createContext(null);



export function useTenant() {

  const context = useContext(TenantContext);

  if (!context) {

    throw new Error('useTenant must be used within TenantProvider');

  }

  return context;

}



/**

 * Tenant identity + config loaded from Firestore.

 * No tenant is selected until the user picks an organization pre-login.

 */

export function TenantProvider({ children }) {

  const [tenantId, setTenantId] = useState(null);

  const [config, setConfig] = useState(null);

  const [configError, setConfigError] = useState(null);

  const [configLoading, setConfigLoading] = useState(false);



  const loadConfigForTenant = useCallback(async (targetTenantId) => {

    setConfigLoading(true);

    setConfigError(null);

    try {

      const { config: resolvedConfig } = await loadTenantConfig(targetTenantId);

      setTenantId(targetTenantId);

      setConfig(resolvedConfig);

    } catch (error) {

      setTenantId(targetTenantId);

      setConfig(null);

      setConfigError(error?.message || 'Nalaganje konfiguracije ni uspelo');

      throw error;

    } finally {

      setConfigLoading(false);

    }

  }, []);



  const switchTenant = useCallback(

    (nextTenantId) => loadConfigForTenant(nextTenantId),

    [loadConfigForTenant]

  );



  const reloadConfig = useCallback(() => {

    if (!tenantId) {

      return Promise.resolve();

    }

    return loadConfigForTenant(tenantId);

  }, [tenantId, loadConfigForTenant]);



  const clearSelectedOrganization = useCallback(() => {

    setTenantId(null);

    setConfig(null);

    setConfigError(null);

    setConfigLoading(false);

  }, []);



  const value = useMemo(

    () => ({

      tenantId,

      config,

      configError,

      configLoading,

      hasSelectedOrganization: Boolean(tenantId && config),

      reloadConfig,

      switchTenant,

      setActiveTenantId: switchTenant,

      clearSelectedOrganization,

      resetConfigForLoggedOut: clearSelectedOrganization,

      isModuleEnabled: (moduleId) => Boolean(config?.modules?.[moduleId]?.enabled),

    }),

    [

      config,

      configError,

      configLoading,

      tenantId,

      reloadConfig,

      switchTenant,

      clearSelectedOrganization,

    ]

  );



  return (

    <TenantContext.Provider value={value}>

      {children}

    </TenantContext.Provider>

  );

}



export default TenantProvider;

